export * from './generic-modal.component'
